import { config } from "../../utils/constants";
import axios from "axios";

export const getMedicalReport = (page) => {
  const requestConfig = {
    url: `${config.medicalReportServices}medicalReport`,
    method: "GET",
    params: { page }
  };
  return axios.request(requestConfig);
};

export const getMedicalReportFee = () => {
  const requestConfig = {
    url: `${config.medicalReportServices}medicalReportFee`
  };
  // console.log("Medical report config >>>", requestConfig)
  return axios.request(requestConfig);
};

export const getMedicalReportAppointmentData = () => {
  const requestConfig = {
    url: `${config.medicalReportServices}appointmentData`,
    method: "GET"
  };

  return axios.request(requestConfig);
};

export const getUserDetails = () => {
  const requestConfig = {
    url: `${config.medicalReportServices}userDetails`,
    method: "GET"
  };
  return axios.request(requestConfig);
};

export const medicalReportPaymentTransation = () => {
  const requestConfig = {
    url: `${config.medicalReportServices}medicalReportPaymentTransation`
  };

  // console.log("medicalReportPaymentTransation >>>", requestConfig)

  return axios.request(requestConfig);
};

export const submitMedicalReportPaymentDetails = (requestBody) => {
  const requestConfig = {
    url: `${config.medicalReportServices}submitMedicalReportPayment`,
    method: 'POST',
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const getLocationDetailsData = (requestBody) => {
  const requestConfig = {
    url: `${config.medicalReportServices}locationDetails`,
    method: 'POST',
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const submitLocationDetailsData = (requestBody) => {
  const requestConfig = {
    url: `${config.medicalReportServices}submitLocation`,
    method: 'POST',
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const getLookupItemData = (requestBody) => {
  const requestConfig = {
    url: `${config.medicalReportServices}lookupItem`,
    method: 'POST',
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const submitLookupItemData = (requestBody) => {
  const requestConfig = {
    url: `${config.medicalReportServices}submitLookupItem`,
    method: 'POST',
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const isMedicalRequestCreated = (requestBody) => {
  const requestConfig = {
    url: `${config.medicalReportServices}medicalRequestCreated`,
    method: 'POST',
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const getSalamaRequestData = (requestBody) => {
  const requestConfig = {
    url: `${config.medicalReportServices}salamaRequestData`,
    method: 'POST',
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const auditEventAndsendMessageInBasket = (requestBody) => {
  const requestConfig = {
    url: `${config.medicalReportServices}sendMessageInBasket`,
    method: 'POST',
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const downloadMedicalReportFe = (requestBody) => {
  const requestConfig = {
    url: `${config.medicalReportServices}downloadMedicalReport`,
    method: 'POST',
    data: requestBody
  };
  // console.log("Medical report config >>>", requestConfig)
  return axios.request(requestConfig);
};

export const submitRhapsodyData = (requestBody) => {
  const requestConfig = {
    url: `${config.medicalReportServices}submitRhapsodyDetails`,
    method: 'POST',
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const getMedicalSpecialtyReport = (requestBody) => {
  const requestConfig = {
    url: `${config.medicalReportServices}medicalSpecialtyReport`,
    method: 'POST',
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const updateViewReportStatus = (requestBody) => {
  const requestConfig = {
    url: `${config.medicalReportServices}updateViewMedicalReport`,
    method: 'POST',
    data: requestBody
  };
  // console.log("Medical report config >>>", requestConfig)
  return axios.request(requestConfig);
};